export default {
      id: "sad-tear-usage",
      viewBox: "0 0 64 64",
      url: "/" + "assets/sprite.svg#sad-tear",
      toString: function () {
        return this.url;
      }
    }